import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const BaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');
const BasePayments = () => import('@/views/dashboard/payments/BasePayments.vue');

const paymentsRoutes: RouteRecordRaw[] = [
    {
        path: '/payments',
        components: {
            default: BaseDashboard,
        },
        meta: {
            title: 'payments',
            icon: 'mdi-credit-card-outline',
            noCache: false,
            isBase: true,
            permissions: ['orders_view'],
            showInMenu: true,
            middleware: ['auth'],
            layout: 'Dashboard',
            showNewUntil: '2026-01-15',
        } as CommonRouteMeta,
        children: [
            {
                path: '',
                components: {
                    default: BasePayments,
                },
                name: 'payments.index',
                meta: {title: 'payments', icon: 'mdi-credit-card-outline', noCache: false, isBase: true},
            },
        ],
    }
];

export default paymentsRoutes;
